export const NEW_FILE_OPTIONS_FOR_MAIN = {
  UPLOAD_FILE: 'Upload file',
  UPLOAD_FOLDER: 'Upload folder',
  ADD_LINK: 'Add a link',
  NEW_FOLDER: 'Create folder',
} as const;

export enum SignatureComponentType {
  REQUEST_SIGN = 'requestSign',
  REQUEST_DATE = 'requestDate',
  REQUEST_INITIAL = 'requestInitial',
  REQUEST_TEXT = 'requestText',
  REQUEST_CHECKBOX = 'requestCheckbox',
  OWNER_SIGN = 'ownerSign',
  OWNER_DATE = 'ownerDate',
  OWNER_INITIAL = 'ownerInitial',
  OWNER_TEXT = 'ownerText',
  OWNER_CHECKBOX = 'ownerCheckbox',
}

export const SignatureComponentTypeLabelMap = {
  signature: 'Signature',
  date: 'Date',
  initials: 'Initials',
  text: 'Text',
  checkbox: 'Checkbox',
} as const;

// Checkbox state is stored in a contract field's `value`. These must match the
// backend's contracts.CheckboxValueChecked; any other value is treated as unchecked.
export const CHECKBOX_CHECKED_VALUE = 'checked';
export const CHECKBOX_UNCHECKED_VALUE = 'unchecked';
